/**
 * Минимальная обёртка над IndexedDB — офлайн-режим пропусков (FR-PASS-01,
 * риск 5 ТЗ §12 «нестабильный мобильный интернет на проходной»).
 * Хранится локально: ключ офлайн-проверки и очередь неотправленных чек-инов.
 */
export function openDb(name: string, version: number, upgrade: (db: IDBDatabase) => void): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    if (typeof indexedDB === 'undefined') {
      reject(new Error('IndexedDB недоступен'));
      return;
    }
    const request = indexedDB.open(name, version);
    request.onupgradeneeded = () => {
      upgrade(request.result);
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error ?? new Error('Ошибка IndexedDB'));
  });
}

function requestToPromise<T>(request: IDBRequest<T>): Promise<T> {
  return new Promise((resolve, reject) => {
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error ?? new Error('Ошибка IndexedDB'));
  });
}

export async function idbPut<T>(db: IDBDatabase, store: string, value: T): Promise<void> {
  const tx = db.transaction(store, 'readwrite');
  await requestToPromise(tx.objectStore(store).put(value as unknown as object));
}

export async function idbGet<T>(db: IDBDatabase, store: string, key: IDBValidKey): Promise<T | undefined> {
  const tx = db.transaction(store, 'readonly');
  return requestToPromise(tx.objectStore(store).get(key)) as Promise<T | undefined>;
}

export async function idbDelete(db: IDBDatabase, store: string, key: IDBValidKey): Promise<void> {
  const tx = db.transaction(store, 'readwrite');
  await requestToPromise(tx.objectStore(store).delete(key));
}

export async function idbAll<T>(db: IDBDatabase, store: string): Promise<T[]> {
  const tx = db.transaction(store, 'readonly');
  return requestToPromise(tx.objectStore(store).getAll()) as Promise<T[]>;
}
